import { useFormik } from "formik";
import React from "react";
import { OrganizationContent } from "../components";
import { ContactUsGuideItem } from "./component";
import {
	ContactUsGuideContent,
	ContactUsGuideItemWrapper,
	ContactUsGuideSubTitle,
	ContactUsGuideTitle,
	ContactUsGuideWrapper,
	ContactUsSendButton,
	ContactUsWrapper,
} from "./style";
import Input from "@/components/Input";
import { useSelector } from "react-redux";
import { getCompanyInfo, getCurrentPlan } from "@/redux/organization/selector";
import { useSnackbar } from "notistack";
import { ContactUsType } from "@/views/Price/types";
import { postContactUs } from "@/views/Price/api";
import { useTranslation } from "react-i18next";

interface InitialValues {
	title: string;
	content: string;
}

export default function OrganizationContact() {
	const { t } = useTranslation();
	const currentPlan = useSelector(getCurrentPlan);
	const companyInfo = useSelector(getCompanyInfo);
	const { enqueueSnackbar } = useSnackbar();

	const initialValues: InitialValues = {
		title: "",
		content: "",
	};

	const { values, getFieldProps, handleSubmit, isSubmitting, resetForm } =
		useFormik<InitialValues>({
			initialValues,
			onSubmit: async ({ title, content }, { setSubmitting }) => {
				try {
					if (!companyInfo || !currentPlan || !title || !content) {
						return;
					}

					setSubmitting(true);
					const type: ContactUsType = "premium";
					// currentPlan.paymentPlan?.planType === "custom"
					// 	? "premium"
					// 	: "normal";

					await postContactUs({
						contents: content,
						title,
						email: companyInfo.email,
						manager: "",
						type,
					});

					enqueueSnackbar("메일이 정상적으로 발송되었습니다.", {
						variant: "success",
					});

					setSubmitting(false);
					resetForm();
				} catch (e) {
					enqueueSnackbar("문의 요청에 실패했습니다.", {
						variant: "error",
					});
					setSubmitting(false);
				}
			},
		});

	return (
		<OrganizationContent title={t("organization_contact_us.title")}>
			<form onSubmit={handleSubmit}>
				<ContactUsWrapper>
					<ContactUsGuideWrapper>
						<ContactUsGuideTitle>
							{t("organization_contact_us.guide_text")}
						</ContactUsGuideTitle>
						<ContactUsGuideSubTitle>
							{t("organization_contact_us.technical_support")}
						</ContactUsGuideSubTitle>
						<ContactUsGuideItemWrapper>
							<ContactUsGuideItem>
								{t("organization_contact_us.technical_support_1")}
							</ContactUsGuideItem>
							<ContactUsGuideItem>
								{t("organization_contact_us.technical_support_2")}
							</ContactUsGuideItem>
							<ContactUsGuideItem last={true}>
								{t("organization_contact_us.technical_support_3")}
							</ContactUsGuideItem>
						</ContactUsGuideItemWrapper>

						<ContactUsGuideSubTitle>
							{t("organization_contact_us.sales_support")}
						</ContactUsGuideSubTitle>
						<ContactUsGuideItemWrapper last={true}>
							<ContactUsGuideItem>
								{t("organization_contact_us.sales_support_1")}
							</ContactUsGuideItem>
							<ContactUsGuideItem>
								{t("organization_contact_us.sales_support_2")}
							</ContactUsGuideItem>
							<ContactUsGuideItem last={true}>
								{t("organization_contact_us.sales_support_3")}
							</ContactUsGuideItem>
						</ContactUsGuideItemWrapper>
					</ContactUsGuideWrapper>
					<ContactUsGuideContent>
						<Input
							placeholder={t(
								"organization_contact_us.mail_title_placeholder",
							)}
							titleText={t("organization_contact_us.mail_title")}
							marginBottom={20}
							{...getFieldProps("title")}
						/>
						<Input
							placeholder={t(
								"organization_contact_us.mail_Contents_placeholder",
							)}
							titleText={t("organization_contact_us.mail_Contents")}
							marginBottom={20}
							rows={5}
							{...getFieldProps("content")}
						/>
						<ContactUsSendButton
							variant="contained"
							backgroundColor="#0071E3"
							disabled={!values.title || !values.content || isSubmitting}
							type="submit"
							height={40}
							loading={isSubmitting}
						>
							{t("organization_contact_us.send_mail")}
						</ContactUsSendButton>
					</ContactUsGuideContent>
				</ContactUsWrapper>
			</form>
		</OrganizationContent>
	);
}
